"use strict";

Shopify.theme.jsFeaturedCollectionList = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollectionList = $.extend(this, Shopify.theme.getSectionData($section));
    this.createSlider($section.attr('id'));
  },
  createSlider: function createSlider(id) {
    var mySwiper = new Swiper('#'+id+' .featured-collection .slider-gallery', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 15,
      centeredSlides: false,
      // Navigation arrows
      navigation: {
        nextEl:  '#'+id+' .swiper-button.next',
        prevEl: '#'+id+' .swiper-button.previous',
      },
      breakpoints: {
        670: {
          slidesPerView: 3,
          spaceBetween:2,
          centeredSlides: true
        }
      }
    });
  }
};